module.exports = __webpack_public_path__ + "static/3-a42d820c678d8c6ecc9e73626f1ceb03.jpg";